import { parseRegExpLiteral } from 'regexpp';

/**
 * @function
 * Regular expression parsing function to separate it from the flag. Returns a flag and a regular expression.
 * @param {String | RegExp} source - Regular expression to be parsed
 */
export default function parseFlagAndRegex(source) {
  if (typeof source === 'string') {
    if (source[0] !== '/') {
      source = `/${source}/`;
    }

    const result = parseRegExpLiteral(source);
    return {
      regex: result.pattern.raw,
      flag: result.flags.raw,
    };
  } else if (source instanceof RegExp) {
    const result = parseRegExpLiteral(source.toString());
    return {
      regex: result.pattern.raw,
      flag: result.flags.raw,
    };
  } else {
    throw new Error('Source must be a string or RegExp');
  }
}
